import { connect } from 'react-redux'
import Heading from 'components/search/Heading'

const mapStateToProps = (state) => ({
  flavour: state.layout.flavour,
  searchType: state.search.searchType
})

export default connect(mapStateToProps, null)(Heading)
